export default __webpack_public_path__ + "static/media/access.39259c92.png";